/**
 * @desc 导出
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.lendMaster.exporting.Params, options?: any) {
  return updateResponse(
    http(URL + `/lendMaster/export`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
